import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class PlayerPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.playerRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.playerImport,
    );
    this.playerAutocomplete = permissionChecker.match(
      Permissions.values.playerAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.playerCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.playerEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.playerDestroy,
    );
  }
}
